"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import {
  TextField,
  Button,
  Box,
  Typography,
  Container,
  AppBar,
  Toolbar,
  Avatar,
  Alert,
  IconButton,
} from "@mui/material"
import { Facebook, WhatsApp, Instagram } from "@mui/icons-material"
const baseUrl = process.env.REACT_APP_APP_URL

const LoginForm = () => {
  const navigate = useNavigate()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState(null)

  const handleSubmit = (e) => {
    e.preventDefault()

    axios
      .post(`${baseUrl}/api/login`, { email, password })
      .then((res) => {
        const { token, user } = res.data

        if (token) {
          if (user.isActive === 1) {
            localStorage.setItem("CC_Token", token)
            localStorage.setItem("user", JSON.stringify(user))
            setError(null) // Clear previous errors
            if (user.role === "instructor") navigate("/InstructorHome")
            else navigate(user.role === "admin" ? "/admin" : "/home")
          } else {
            setError("Votre compte n'est pas encore activé.")
          }
        } else {
          setError("Email ou mot de passe incorrect.")
        }
      })
      .catch((err) => {
        console.error(err)
        setError("Erreur de connexion. Vérifiez vos informations.")
      })
  }

  return (
    <div>
      <AppBar position="fixed" sx={{ backgroundColor: "#003366" }}>
        <Toolbar>
          <Avatar alt="Logo" src="../assets/cej.png" sx={{ width: 40, height: 40, marginRight: "0.5rem" }} />
          <Typography variant="h6" sx={{ flexGrow: 1, fontSize: { xs: "1rem", sm: "1.25rem" }, color: "#ffffff" }}>
            Club Équestre Jafoura
          </Typography>
        </Toolbar>
      </AppBar>

      <Container
        maxWidth="sm"
        sx={{
          marginTop: "100px",
          padding: "2rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "8px",
        }}
      >
        <Typography variant="h4" sx={{ textAlign: "center", marginBottom: "1rem", color: "#003366" }}>
          Connexion
        </Typography>
        {error && (
          <Alert severity="error" sx={{ marginBottom: "1rem" }}>
            {error}
          </Alert>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            type="email"
            sx={{ marginBottom: "1rem" }}
          />
          <TextField
            label="Mot de passe"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            type="password"
            sx={{ marginBottom: "1rem" }}
          />
          <Button
            variant="contained"
            fullWidth
            type="submit"
            sx={{
              backgroundColor: "#003366",
              color: "#fff",
              marginTop: "1rem",
              "&:hover": { backgroundColor: "#00509d" },
            }}
          >
            Connexion
          </Button>
          {/* Nouveau bouton pour la réservation des box - accessible sans login */}
          <Button
            variant="outlined" // Utilisation de 'outlined' pour le distinguer du bouton de connexion
            fullWidth
            onClick={() => navigate("/reservationBox")} // Cette action ne dépend pas de l'état de connexion
            sx={{
              color: "#003366",
              borderColor: "#003366",
              marginTop: "1rem",
              "&:hover": { borderColor: "#00509d", backgroundColor: "rgba(0, 51, 102, 0.04)" },
            }}
          >
            Réserver une box
          </Button>
        </form>
        <Box sx={{ textAlign: "center", marginTop: "1rem" }}>
          <Typography variant="body2">
            Vous n'avez pas de compte ?
            <Button onClick={() => navigate("/register")} sx={{ textTransform: "none", color: "#003366" }}>
              Inscrivez-vous
            </Button>
          </Typography>
        </Box>

        {/* Social Media Icons */}
        <Box sx={{ display: "flex", justifyContent: "center", gap: "1rem", marginTop: "1.5rem" }}>
          <IconButton
            href="https://www.facebook.com/club.jafoura.sfax?locale=fr_FR"
            target="_blank"
            sx={{ color: "#1877f2" }}
          >
            <Facebook fontSize="large" />
          </IconButton>
          <IconButton
            component="a"
            href="https://wa.me/+21625900901?text=Contact%2C%20Us!"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: "#25D366" }}
          >
            <WhatsApp fontSize="large" />
          </IconButton>
          <IconButton
            href="https://www.instagram.com/club_equestre_jafoura/?hl=fr"
            target="_blank"
            sx={{ color: "#e1306c" }}
          >
            <Instagram fontSize="large" />
          </IconButton>
        </Box>
      </Container>
    </div>
  )
}

export default LoginForm
